<script setup lang="ts">
import { ref } from "vue";
import IntegrationDO = App.Data.Integrations.IntegrationDO;
import DynamicSettingsForm from "@/modules/integrations/components/DynamicSettingsForm.vue";
import { toastApiResult } from "@/toaster";
import { useApiClient } from "@/api/client";
import { t } from "../../../plugins/i18n";

const props = defineProps<{
	integration: IntegrationDO;
}>();

const localIntegration = ref({ ...props.integration });

const integrationAvailabilities = ref([
	{
		name_clean: "available_on_reservation_segments",
		icon: "fa-object-intersect",
	},
]);

const saveIntegration = async () => {
	const response = await toastApiResult(
		useApiClient("integrations").patch(localIntegration.value)
	);
};
</script>

<template>
	<v-card class="pa-3">
		<dynamic-settings-form
			v-if="localIntegration.uuid"
			v-model="localIntegration.required_credentials"
		/>
		<div class="pt-5">
			<label class="text-h6">Integration Availability: </label>
		</div>
		<v-divider class="my-2" />
		<div
			v-for="integrationAvailability in integrationAvailabilities"
			:key="integrationAvailability.name_clean"
		>
			<div class="d-flex align-sm-center align-start">
				<v-avatar size="48" class="mr-2" rounded="md" color="lightprimary">
					<i
						:class="`fa-duotone ${integrationAvailability.icon} fa-lg text-primary`"
					></i>
				</v-avatar>
				<div class="pl-4">
					<h6 class="text-h6 mb-1 mt-1">
						{{
							t(
								`integrations.availabilities.${integrationAvailability.name_clean}.title`
							)
						}}
					</h6>
					<h5 class="text-subtitle-1 text-medium-emphasis">
						{{
							t(
								`integrations.availabilities.${integrationAvailability.name_clean}.description`
							)
						}}
					</h5>
				</div>
				<div class="ml-auto mr-1 pa-sm-1 pa-6 pl-7">
					<v-switch
						v-model="localIntegration.available_in"
						color="primary"
						:value="integrationAvailability.name_clean"
						hide-details
						density="compact"
					></v-switch>
				</div>
			</div>
		</div>
		<v-divider class="mt-2 mb-5" />
		<div class="mt-5 d-flex">
			<v-spacer />
			<v-btn color="primary" variant="flat" @click="saveIntegration"
				>Save</v-btn
			>
		</div>
	</v-card>
</template>

<style scoped lang="scss"></style>
